import { Outlet } from 'react-router-dom'
import { Layout } from 'antd'
import ComponentHeader from '@/components/Layout/Header'
import Menu from '@/components/Layout/Menu'
import { useThemeMode } from '@/theme/ThemeContext'
import '../index.scss'

const { Sider, Content } = Layout;

export default function RootLayout() {
    const { isDarkMode } = useThemeMode()
    return (
        <div
            className={isDarkMode ? 'dark' : 'light'}
            style={{
                backgroundColor: 'rgb(var(--background))',
                color: 'rgb(var(--foreground))',
            }}
        >
            <ComponentHeader/>
            <Layout className="min-w-1024 min-w-body-1024 flex w-full max-w-8xl mx-auto">
                <Sider
                    width={220}
                    style={{
                        backgroundColor: 'rgb(var(--background))',
                        borderColor: 'var(--border)',
                        borderRight: '1px solid var(--border)',
                        position: 'sticky',
                        top: '60px',
                        height: 'calc(100vh - 60px)',
                        overflow: 'auto',
                    }}
                >
                    <Menu />
                </Sider>
                <Content>
                    <div className="page-container">
                        <Outlet />
                    </div>
                </Content>
            </Layout>
        </div>
    )
}
